import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { HeaderModule } from '../shared/components/header/header.module';
import { FooterModule } from '../shared/components/footer/footer.module';

import {DevelopmentComponent} from './development.component';
import {DevelopmentRoutingModule} from './development-routing.module';
import {DevelopmentRoutesModule} from './routes/routes.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    HeaderModule,
    FooterModule,
    DevelopmentRoutesModule,
    DevelopmentRoutingModule
  ],
  providers: [],
  exports: [DevelopmentComponent],
  declarations: [
    DevelopmentComponent
  ]
})

export class DevelopmentModule {}
